<template>
    <div class="set_self_project_res">
        <v-offline online-class="online" offline-class="offline" @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <el-row class="setMarginTop">
            <el-col>
                <div class="panel-heading">
                    <h5>Records > Catch Release > List {{ activeAreaName }}</h5>
                    <hr>
                </div>
            </el-col>
        </el-row>
        <!-- <div class="row setMarginTop">
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Total Animals</p>
                            {{ stats.total_animals }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Male</p>
                            {{ stats.total_males }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Female</p>
                            {{ stats.total_female }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Young</p>
                            {{ stats.total_young }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Senior</p>
                            {{ stats.total_senior }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Adult</p>
                            {{ stats.total_adult }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Lactating</p>
                            {{ stats.total_lactating }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Pregnant</p>
                            {{ stats.total_pregnant }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Owned</p>
                            {{ stats.total_owned }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Owned free roaming</p>
                            {{ stats.total_owned_free_roaming }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Community</p>
                            {{ stats.total_community }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Community free roaming</p>
                            {{ stats.total_community_free_roaming }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Wild</p>
                            {{ stats.total_wild }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Areas</p>
                            {{ areas.length ? areas.length : 0 }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>Field Users</p>
                            {{ stats.total_field_users }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row setMarginTop">
            <div v-for="(species, index) in stats.species" class="col-xs-6 col-sm-6 col-md-2" :key="index">
                <div class="card setShadow">
                    <div class="card-body">
                        <div class="numbers">
                            <p>{{ species.name }}</p>
                            {{ species.count }}
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-sm-12 col-xs-12 col-md-12 col-xl-12">
                <div class="card">
                    <div class="card-body">
                        <table id="catchRecords" class="display table-striped table-bordered select" cellspacing="0"
                            width="100%">
                            <thead>
                                <tr>
                                    <th>Date Time</th>
                                    <th>Image</th>
                                    <th>RFID</th>
                                    <th>App ID</th>
                                    <th>Species</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th>Ownership</th>
                                    <th>Area</th>
                                    <th>Field User</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- The Modal -->
        <div id="image-modal" class="modal_full_img">
            <span class="close close-image-modal">&times;</span>
            <img class="modal-content-full-img" id="image-modal-src">
        </div>
    </div>
</template>
<script>
import { Row, Col } from 'element-ui'
import mixin from '../../../../../mixins/GlobalMixin';
import VOffline from 'v-offline';

export default {
    components: {
        VOffline,
        [Row.name]: Row,
        [Col.name]: Col,
    },
    props: {
        projectId: {
            type: Number,
            default: 0
        },
        areaId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isReadOnly: false,
            projectName: "",
            table: null,
            stats: [],
            areas: [],
            activeAreaName: '',
            projectLevelView: false,
        }
    },
    mixins: [mixin],
    methods: {
        getStatsData() {
            // TODO: need stats api
            let url = "/stats/vaccination/" + this.projectId;
            if (this.areaId > 0) {
                url = "/stats/vaccinationByArea/" + this.areaId;
            }
            axios.get(url)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        let vm = this;
                        vm.stats = response.data.response.data.stats;
                    }
                })
                .catch(error => {
                    if (error.response.data.response.error) {

                    }
                });
        },
        init() {
            this.getCatchReleaseRecords();
        },
        getCatchReleaseRecords() {
            let vm = this;

            if (vm.table != null) {
                vm.table.destroy();
            }
            try {
                vm.table = $('#catchRecords').DataTable({
                    "scrollX": true,
                    responsive: true,
                    dom: 'lBfrtip',
                    "bInfo": false,
                    "order": [[1, "desc"]],
                    'columns': [
                        {
                            'targets': 0,
                            'render': function (data, type, full, meta) {
                                return vm.formatRecordDisplayDate(full[1], 'DD MMM YYYY, HH:mm:ss', ',');
                            },
                        }, {
                            'targets': 1,
                            'render': function (data, type, full, meta) {
                                return type !== 'export'
                                    ? '<img src=' + full[2] + ' class="datatable_image_thumbnail" style="cursor: pointer; object-fit: cover;" height="70" width="70"/>'
                                    : full[2];
                            },
                            "searchable": false
                        }, {
                            'targets': 2,
                            'render': function (data, type, full, meta) {
                                return full[3];
                            },
                        }, {
                            'targets': 3,
                            'render': function (data, type, full, meta) {
                                return full[4];
                            },
                        }, {
                            'targets': 4,
                            'render': function (data, type, full, meta) {
                                return full[5];
                            },
                        }, {
                            'targets': 5,
                            'render': function (data, type, full, meta) {
                                return full[6];
                            },
                        }, {
                            'targets': 6,
                            'render': function (data, type, full, meta) {
                                return full[7];
                            },
                        }, {
                            'targets': 7,
                            'render': function (data, type, full, meta) {
                                return full[8];
                            },
                        }, {
                            'targets': 8,
                            'render': function (data, type, full, meta) {
                                return full[9];
                            },
                        }, {
                            'targets': 9,
                            'render': function (data, type, full, meta) {
                                return full[10];
                            },
                        }
                    ],
                    buttons: [
                        {
                            extend: 'excel',
                            text: 'Export to excel',
                            className: 'btn btn-default',
                            exportOptions: {
                                columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                            }
                        }
                    ],
                    'fnRowCallback': function (nRow, aData, iDisplayIndex) {
                        const imageElement = $('.datatable_image_thumbnail', nRow);
                        vm.zoomImagePopup(imageElement);
                        return nRow;
                    },
                    "processing": true,
                    "serverSide": true,
                    "ajax": {
                        "url": `${window.DATATABLES_BASE_URL}pm/catching/records/by/area`,
                        "type": "POST",
                        "data": {
                            project_id: vm.projectId,
                            selected_area: vm.areaId,
                        },
                    },
                    lengthMenu: [[15, 100, -1], [15, 100, "All (Warning: Slow)"]],
                    pageLength: 15,
                });
            } catch (e) {
                console.log(e);
            }

        },
        showFullSizeImage(src) {
            var modal = document.getElementById("image-modal");
            var modalImg = document.getElementById("image-modal-src");
            modal.style.display = "block";
            modalImg.src = src;
            var span = document.getElementsByClassName("close-image-modal")[0];
            span.onclick = function () {
                modal.style.display = "none";
            }
        }
    },
    mounted() {
        let vm = this;
        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true
            }
        })
        let project = vm.$store.getters.getCurrentSelectedProject;
        vm.areas = project.areas;
        vm.projectName = project.name;
        vm.projectId = project.id;

        if (localStorage.getItem('vaccinationProjectLevelViewList') == 1) {
            vm.activeAreaName = "> Project Level View";
            vm.projectLevelView = true;
        } else {
            vm.activeAreaName = "> Area (" + localStorage.getItem('VaccinationAreaName') + ")";
            vm.projectLevelView = false;
        }

        vm.init();
        // TODO: call when api is ready
        // vm.getStatsData();
    }
}

</script>
<style lang="scss" scoped>
.setWhite {
    background-color: white;
}

.card .card-body {
    text-align: center;
}

.setMarginTop {
    margin-top: 11px;
    /* margin-bottom: 11px; */
}

.setShadow {
    box-shadow: 0 6px 10px 0px rgba(0, 0, 0, 0.15) !important;
}

.card .numbers p {
    color: #9A9A9A;
    font-size: 14px;
    margin: 0;
}

.card .numbers {
    font-size: 1.5em !important;
}

.modal_full_img {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1051;
    width: 100%;
    padding: 20px;
    height: 100%;
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.66);
    /* Black w/ opacity */
    display: none;
}

/* Modal Content (image) */
.modal-content-full-img {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    //height: 100%;
}

/* Add Animation */
.modal-content-full-img {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close-image-modal {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.close-image-modal:hover,
.close-image-modal:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content-full-img {
        width: 100%;
    }
}
</style>
